<template>
    <div class="approval-list">
        <div class="search-box">
            <el-form :inline="true" class="demo-form-inline">
               <el-form-item label="审批类型">
                    <BusinessTree
                        ref="treeChild"
                        :popover="true"
                        :data="treeData"
                        :defaultProps="defaultProps"
                        :defaultClass="'business-tree-form'"
                        :key="timer"
                        @nodeClick="handleTreeNode"
                    />
                </el-form-item>
                <el-form-item label="审批名称">
                    <el-input style="width: 170px;" maxlength="100" @change="handleSearch" v-model.trim="searchParams.approvalName" placeholder="审批流名称">
                    </el-input>
                </el-form-item>
                <el-form-item  label="所属流程">
                    <el-input style="width: 170px;" maxlength="100" @change="handleSearch" v-model.trim="searchParams.busiProcessInstanceName" placeholder="审批流所属的流程名称">
                    </el-input>
                </el-form-item>
                <el-form-item  label="任务名称">
                    <el-input style="width: 170px;" maxlength="100" @change="handleSearch" v-model.trim="searchParams.taskName" placeholder="所属任务名称">
                    </el-input>
                </el-form-item>
                <el-form-item  label="审批状态">
                      <el-select v-model="searchParams.approvalStatus" placeholder="请选择" @change="handleSearch">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                </el-form-item>
                <el-form-item >
                  <el-select v-model="searchParams.approvalPeopleType" placeholder="请选择" style="width:100px;" @change="handleSearch">
                    <el-option 
                        label="申请人"
                        value="1">
                    </el-option>
                    <el-option 
                        label="审批人"
                        value="2">
                    </el-option>
                 </el-select>
                <el-input readonly style="width: 170px;" :title="searchParams.selectedUserNames" v-model="searchParams.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg' :multiple='true' :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
               </el-form-item>
                <el-form-item label="申请起止时间">
                  <el-date-picker
                       v-model="searchParams.rangeTime"
                       type="daterange"
                       :editable="true"
                       value-format="yyyy-MM-dd"
                       range-separator="至"
                       start-placeholder="开始日期"
                       end-placeholder="结束日期">
                     </el-date-picker>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" title="审批数据查询" circle @click="handleSearch"></el-button>
                <el-button icon="el-icon-download" type="success" @click="exportAllApproveList" :loading="exportLoading">导出审批</el-button>
            </el-form>
        </div>
        <div class="approve-box">
              <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column
                  prop="approvalName"
                  label="审批名称"
                  :show-overflow-tooltip="true"
                  width="300">
                </el-table-column>
                <el-table-column
                  prop="applyUserName"
                  label="申请人"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="applyUserDept"
                  :show-overflow-tooltip="true"
                  width="120"
                  label="所属部门">
                </el-table-column>
                <el-table-column
                  label="审批状态"
                  width="90"
                  >
                  <template slot-scope="scope">
                      <el-button size="mini" type="info" v-if="scope.row.approvalStatus==0" round>草稿</el-button>
                      <el-button size="mini" type="primary" v-if="scope.row.approvalStatus==1" round>审批中</el-button>
                      <el-button size="mini" type="success" v-if="scope.row.approvalStatus==2" round>通过</el-button>
                      <el-button size="mini" type="danger"  v-if="scope.row.approvalStatus==3" round>驳回</el-button>
                      <el-button size="mini" type="warning"  v-if="scope.row.approvalStatus==4" round>终止</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="approvalTypeName"
                  width="100"
                  :show-overflow-tooltip="true"
                  label="审批类型">
                </el-table-column>
                <el-table-column
                  prop="taskName"
                  width="120"
                  :show-overflow-tooltip="true"
                  label="所在任务">
                </el-table-column>
                <el-table-column
                  prop="created"
                  width="160"
                  label="申请时间">
                </el-table-column>
                <el-table-column
                  label="审批流状态"
                  align="center"
                  >
                  <template slot-scope="scope">
                    <div>
                        <!-- <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalMethod != 3 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                            <el-step v-for="(item, index) in scope.row.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''"></el-step>
                        </el-steps>
                        <el-steps v-if="(scope.row.approvalMethod == 2 || scope.row.approvalMethod == 3) && scope.row.approvalTotalNum>0" align-center finish-status="success">
                            <el-step v-for="(item, index) in scope.row.approVoList" :class="activeClass(item)" :key="index" align-center :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''">
                                <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps> -->
                      <el-steps v-if="scope.row.approvalMethod == 1 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                          <el-step v-for="(item, index) in scope.row.users" :class="activeClass(item)" :key="index" :title="item.trueName" :description="item.hasOwnProperty('approvalRemarks')?item.approvalRemarks:''"></el-step>
                      </el-steps>
                      <el-steps v-if="scope.row.approvalMethod > 1 && scope.row.approvalTotalNum>0" align-center finish-status="success">
                          <el-step v-for="(item, index) in scope.row.approVoList" :class="activeClass(item)" :key="index" align-center :description="''">
                              <el-breadcrumb v-if="item && item.list.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                  <el-breadcrumb-item  v-for="(user, i) in item.list" :key="i" :class="activeUserClass(user)">{{user.trueName}}</el-breadcrumb-item> 
                              </el-breadcrumb>
                          </el-step>
                      </el-steps>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="220">
                  <template slot-scope="scope">
                        <el-button  size="mini"  title="查看"  @click="handleView(scope.row)">查看</el-button>
                        <el-button   size="mini" type="danger"  @click="handleDelete(scope.row)">删除</el-button>
                        <el-button   size="mini" type="info" @click="transferApproval(scope.row)" v-if="scope.row.approvalStatus==1">转办</el-button>
                  </template>
                </el-table-column>
              </el-table>
        </div>
        <div class="data-page">
            <el-row type="flex" justify="end">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :total="page.totalPageNum"
                    :current-page="page.currentPage"
                    :page-size="page.pageSize"
                    :page-sizes="[10, 20, 30, 50]"
                    @current-change="queryFormData"
                    @size-change="queryFormDataByPageSize"
                />
            </el-row>
        </div>
        <el-dialog
            :title="approvalTitle"
            width="90%"
            top="0vh"
            class="show-all-approval-pop-dialog"
            append-to-body
            fullscreen
            :visible.sync="isShowApprovalPop"
            >
            <ApprovalPop
                    :key="loadTimer"
                    ref="approvalPop"
                    :isRough="isRough"
                    :instances="instances"
                    :isInstance="isInstance"
                    :approvalInfo="approvalInfo"
                    :approvalTemplateObj="templateInfo"
                    :btnMode="btnMode"
                    :isRead="isRead"
                    :isShowCopyUser="isShowCopyUser"
                    :busiProcessInstanceId="busiProcessInstanceId"
                    :approvalStatus="approvalStatus"
                    :busiTaskInstanceId="busiTaskInstanceId"
                    :taskParam="taskParam" />

        </el-dialog>
        <UserOrgPop :key="loadTimer2" :isShowUserOrg='isShowTransferUser' :multiple='false' :selectedUser="selectedTransferUser" ref="transferUserOrgPop" @nodeClick="transferSelectTrigger" />
    </div>
</template>

<script>
  
import { API_ALL_APPROVE_LIST_EXPORT_TO_ALL_EXCEL_PARAM} from '@/common/constants';
import { getAllAproveList, getBusinessTreeList, deleteApprovalInstance, getFormConfigs, updateApprovalUser } from '@/data-model';

import ApprovalPop from '@/components/ApprovalPop';
export default{
      components: {
          ApprovalPop
      },
      props: {
          approvalStatus: {
              type: Number
          },
          busiProcessInstanceId: {
              type: String
          },
          busiTaskInstanceId: {
              type: String
          },
          taskParam: {
              type: Object
          }
      },
      data () {
          return {
              tableData: [],
              page: {
                  currentPage: 1, // 当前页码
                  pageSize: 10, // 每页条数
                  totalPageNum: 0 // 总页数
              },
              treeData: [],
              defaultProps: {
                  children: 'children',
                  label: 'label'
              },
              searchParams: {
                  processDefinitionId: '',
                  serviceName: '',
                  producer: '',
                  serviceType: '',
                  state: null,
                  busiProcessInstanceId: '',
                  busiTaskInstanceId: '',
                  isOther: false,
                  isCopyFlag: 0,
                  approveFromIds: '',
                  busiProcessInstanceName: '',
                  taskName: '',
                  approvalPeopleType: '1',
                  rangeTime: '',
                  beginDate: '',
                  endDate: ''
              },
              timer: '',
              approvalTitle: '',
              isShowApprovalPop: false,
              loadTimer: '',
              instances: {
                  id: '',
                  formObj: {}
              },
              isRough: false,
              isInstance: false,
              approvalInfo: {
                  approvalRemarks: '',
                  selectedCopyUserIds: '',
                  selectedCopyUserNames: ''
              },
              templateInfo: {
                  id: '',
                  templateName: '',
                  busiType: '',
                  busiTypeName: '',
                  remarks: '',
                  selectedUser: {
                      selectedUserIds: '',
                      selectedUserNames: ''
                  },
                  templateState: null,
                  forms: [],
                  users: [],
                  dataOperate: {
                      dataSource: 2,
                      forms: []
                  },
                  parentApprovalId: '',
                  approvalMethod: 1,
                  mainApprovalId: ''
              },
              btnMode: 0,
              isRead: false,
              isShowCopyUser: false,
              options: [{
                  value: '0',
                  label: '草稿'
              }, {
                  value: '1',
                  label: '审批中'
              }, {
                  value: '2',
                  label: '通过'
              }, {
                  value: '3',
                  label: '驳回'
              }, {
                  value: '4',
                  label: '终止'
              }],
              isShowProcessUserOrg: false,
              selectedProcessUser: {
                  selectedUserIds: '',
                  selectedUserNames: ''
              },
              transferApprovalData: {},
              isShowTransferUser: false,
              loadTimer2: '',
              catchUserId: '',
              selectedTransferUser: {
                  selectedUserIds: '',
                  selectedUserNames: ''
              },
              exportLoading: false
          };
      },
      async created () {
          this.initDatetimerange();
          let loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
          });
          await this.initBusinessTreeList();
          await this.getAllAproveList();
          loading.close();
      },
      methods: {
          activeUserClass (item) {
              if (item.stepStatus === 1) {
                  return 'success-user';
              } else if (item.stepStatus === 2) {
                  return 'reject-user';
              } else if (item.stepStatus === 99) {
                  return 'now-user';
              } else {
                  return '';
              }
          },
          initDatetimerange () {
              var date = new Date();
              var y = date.getFullYear();
              var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
              var d = date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate();
              // var sMonth = y + '-' + '01';
              // var eMonth = `${y}-${m}`;
              //   var sDay = y + '-' + '01' + '-' + '01';// 本年第一天
              var sDay = this.haflYear();// 本年第一天
              var eDay = `${y}-${m}-${d}`; // 本月今天
              this.searchParams.rangeTime = [sDay, eDay];
          },
          haflYear () {
              // 先获取当前时间
              let curDate = (new Date()).getTime();
              // 将半年的时间单位换算成毫秒
              let halfYear = 365 / 2 * 24 * 3600 * 1000;
              // 半年前的时间（毫秒单位）
              let pastResult = curDate - halfYear;
              // 日期函数，定义起点为半年前
              let pastDate = new Date(pastResult);
              let pastYear = pastDate.getFullYear();
              let pastMonth = pastDate.getMonth() + 1;
              let pastDay = pastDate.getDate();
              if (pastMonth >= 1 && pastMonth <= 9) {
                  pastMonth = '0' + pastMonth;
              }
              if (pastDay >= 0 && pastDay <= 9) {
                  pastDay = '0' + pastDay;
              }
              let endDate = pastYear + '-' + pastMonth + '-' + pastDay;
              return endDate;
          },
          async getAllAproveList () {
              let loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              this.searchParams.beginDate = null;
              this.searchParams.endDate = null;
              if (this.searchParams.rangeTime) {
                  this.searchParams.beginDate = this.searchParams.rangeTime[0];
                  this.searchParams.endDate = this.searchParams.rangeTime[1];
              }
              let param = {currentPage: this.page.currentPage, pageSize: this.page.pageSize};
              let res = await getAllAproveList(Object.assign(param, this.searchParams));
              if (res && res.state === 'success') {
                  this.tableData = res.approveList;
                  this.page.totalPageNum = res.count;
              }
              loading.close();
          },
          async initBusinessTreeList () {
              let businessTreeList = await getBusinessTreeList();
              this.treeData = businessTreeList;
              this.timer = new Date().getTime();
          },
          queryFormData (currentPage) {
              this.page.currentPage = currentPage;
              this.getAllAproveList();
          },
          queryFormDataByPageSize (pageSize) {
              this.page.pageSize = pageSize;
              this.getAllAproveList();
          },
          handleSearch () {
              this.getAllAproveList(1);
          },
          handleTreeNode (data, node, tree) {
              this.searchParams.approvalType = data.id;
              this.handleSearch();
          },
          activeClass (item) {
              if (item.stepStatus === 1) {
                  return 'success-step';
              } else if (item.stepStatus === 2) {
                  return 'reject-step';
              } else if (item.stepStatus === 99) {
                  return 'now-step';
              } else {
                  return '';
              }
          },
          async initStruct (row) {
              let formIds = [];
              row.forms.forEach(element => {
                  formIds.push(element.formId);
              });
              let formsMap = await getFormConfigs(formIds.join(','));
              this.instances.formObj = {};
              this.instances.formObj.structure = [];
              this.instances.formObj.instance = row.formValues;
              for (var key in formsMap) {
                  if (formsMap[key]) {
                      this.instances.formObj.structure.push(formsMap[key]);
                  }
              }
          },
          async initApprovalPop (row) {
              this.selectedRowId = row.id;
              this.templateInfo = row;
              this.templateInfo.selectedUser = {};
              this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
              this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;
              this.templateInfo.templateName = row.approvalName;
              this.templateInfo.busiType = row.approvalType;
              this.templateInfo.busiTypeName = row.approvalTypeName;
              this.templateInfo.opType = row.opType;
              this.instances.id = row.processInstanceId;
              this.isInstance = true;
              this.loadTimer = new Date().getTime();
              await this.initStruct(row);
              setTimeout(() => { // 默认回显值
                  this.$refs.approvalPop._initPage();
              }, 0);
          },
          async handleView (row) {
              this.approvalTitle = row.approvalName;
              this.btnMode = 2;
              row.opType = 0;
              await this.initApprovalPop(row);
              this.isRead = true;
              this.isShowApprovalPop = true;
          },
          handleDelete (row) {
              let loading = '';
              this.$confirm(`您确定要删除审批数据吗？`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(async (res) => {
                  loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  await deleteApprovalInstance(row.id);
                  await this.getAllAproveList();
                  this.isShowApprovalPop = false;
                  loading.close();
              }).catch(() => {
                  loading.close();
              });
          },
          chooseProcessAssigneeUser () {
              this.loadTimer = new Date().getTime();
              setTimeout(() => { // 初始化
                  this.$refs.processUserOrgPop._initPage();
              }, 0);
              this.isShowProcessUserOrg = true;
          },
          processAssigneeSelectTrigger (selected) { // 流程负责人
              this.selectedProcessUser = selected;
              this.searchParams.selectedUserIds = this.selectedProcessUser.selectedUserIds;
              this.searchParams.selectedUserNames = this.selectedProcessUser.selectedUserNames;
              this.handleSearch();
          },
          transferApproval (row) {
              let approvalList = row.approvalList;
              for (let i = 0; i < approvalList.length; i++) {
                  let item = approvalList[i];
                  let flag = false;
                  item.forEach(obj => {
                      if (obj.approvalResult === 0) { // 存在未审批的人,
                          flag = true;
                      }
                  });
                  if (flag) { // 不用继续下去了
                      if (item.length > 1) { // 暂不支持多人转办
                          this.$message.error('节点存在多个人，不支持转办,请联系审核人去待审批页面转办');
                      } else { // 记录被转办人的id
                          this.catchUserId = item[0].userId;
                      }
                      break;
                  }
              }
              this.loadTimer2 = new Date().getTime();
              // 展现人员
              setTimeout(() => { // 初始化
                  this.$refs.transferUserOrgPop._initPage();
              }, 0);
              this.transferApprovalData = row;
              this.isShowTransferUser = true;
          },
          async transferSelectTrigger (selected) {
              // 判断当前人是否在此流程上
              let approvalList = this.transferApprovalData.approvalList;
              let canTransfer = false;
              approvalList.forEach(item => {
                  console.log(selected.selectedUserIds);
                  item.forEach(item1 => {
                      if (selected.selectedUserIds === item1.userId) {
                          canTransfer = true;
                      }
                  });
              });
              if (canTransfer) { // 审批流存在此人，转办失败
                  this.$message.error('审批流存在此人，转办失败');
              } else { // 开始转办
                  let param = {id: this.transferApprovalData.id, transferUserid: selected.selectedUserIds, currentUserId: this.catchUserId};
                  let res = await updateApprovalUser(param);
                  if (res.state === 'success') {
                      this.handleSearch();
                  } else {
                      this.$message.error(res.msg);
                  }
              }
          },
          async exportAllApproveList () {
              this.exportLoading = true;
              this.searchParams.beginDate = null;
              this.searchParams.endDate = null;
              if (this.searchParams.rangeTime) {
                  this.searchParams.beginDate = this.searchParams.rangeTime[0];
                  this.searchParams.endDate = this.searchParams.rangeTime[1];
              }
              let url = `${API_ALL_APPROVE_LIST_EXPORT_TO_ALL_EXCEL_PARAM}`;
              url = url.replace(':approvalType', this.searchParams.approvalType ? this.searchParams.approvalType : 'null');// 审批类型
              url = url.replace(':approvalName', this.searchParams.approvalName ? this.searchParams.approvalName : 'null');// 审批名称
              url = url.replace(':busiProcessInstanceName', this.searchParams.busiProcessInstanceName ? this.searchParams.busiProcessInstanceName : 'null');// 流程名称
              url = url.replace(':taskName', this.searchParams.taskName ? this.searchParams.taskName : 'null');// 任务名称
              url = url.replace(':approvalStatus', this.searchParams.approvalStatus ? this.searchParams.approvalStatus : 'null');// 审批状态
              url = url.replace(':approvalPeopleType', this.searchParams.approvalPeopleType ? this.searchParams.approvalPeopleType : 'null');// 人员类型：申请人 审批人
              url = url.replace(':selectedUserIds', this.searchParams.selectedUserIds ? this.searchParams.selectedUserIds : 'null');// 人员ids
              url = url.replace(':beginDate', this.searchParams.beginDate ? this.searchParams.beginDate : 'null');// 开始时间
              url = url.replace(':endDate', this.searchParams.endDate ? this.searchParams.endDate : 'null');// 截止时间

              this.exportLoading = true;
              this.download(url);
              setTimeout(() => { // 导出按钮转圈圈关闭
                  this.exportLoading = false;
              }, 5000);
          },
          download (url) {
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = url;
              document.body.appendChild(iframe);
          }
      }
};
</script>

<style lang="less">
    .approval-list {
        height: 100%;
        .tools-bar{
            height:auto;
            min-height:40px;
            position:static;
        }
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
        .el-step__main .el-breadcrumb{
            display: inline-block;
        }
        .success-step{
          .el-step__head{
              color: #67c23a;
              border-color: #67c23a;
              .is-success{
                color: #67c23a;
                border-color: #67c23a;
              }
          }
          .el-breadcrumb__inner{
                color: #c0c4cc;
                .is-success{
                    color: #67c23a;
                    border-color: #67c23a;
                }
           }
           .success-user .el-breadcrumb__inner{
               color: #67c23a;
           }
          .el-step__title{
              color: #67c23a;
          }
          .el-step__description{
              color: #303133;
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #67c23a;
            color: #67c23a;
          }
        }
        .reject-step{
          .el-step__head{
              color: #f56c6c;
              border-color: #f56c6c;
          }
           .el-breadcrumb__inner{
                color: #c0c4cc;
           }
           .reject-user .el-breadcrumb__inner{
               color: #f56c6c;
           }
          .el-step__title{
              color: #f56c6c;
          }
          .el-step__description{
              color: #303133;
          }
          // .el-step__line {
          //   position: absolute;
          //   border-color: inherit;
          //   background-color: #f56c6c;
          //   color: #f56c6c;
          // }
        }
// is-wait
        .now-step{
          .el-step__head{
              color: #409eff;
              border-color: #409eff;
              .is-success{
                color: #409eff;
                border-color: #409eff;
              }
          }
          .el-breadcrumb__inner{
                color: #409eff;
                border-color: #409eff;
                .is-success{
                    color: #409eff;
                    border-color: #409eff;
                }
            }
          .el-step__title{
              color: #409eff;
              .is-process{
                font-weight: 700;
              }
          }
          .el-step__line {
            position: absolute;
            border-color: inherit;
            background-color: #409eff;
            color: #409eff;
          }
        }
        .success-user .el-breadcrumb__inner{
            color: #67c23a;
        }
        .el-tabs__content{
          margin-top: 2px;
        }
        // .el-dialog__footer{
        //     padding: 5px 20px 10px;
        // }
        .el-dialog__header{
          padding: 5px 20px 10px;
        }
        .el-dialog__footer{
          padding: 65px 20px 5px 5px;
        }
        .el-dialog__body{
          height: 540px;
          padding: 5px 5px;
        }
        // .el-dialog__wrapper{
        //   overflow:hidden;
        // }

        .demo-table-expand {
          font-size: 0;
          .approval-steps{
            .el-form-item__content{
              margin-left: -10%;
              width: 95%;
            }
          }
        }
        .demo-table-expand label {
          width: 90px;
          color: #99a9bf;
        }
        .demo-table-expand .el-form-item {
          margin-right: 0;
          margin-bottom: 0;
          width: 33%;
        }
        .approval-info{
          .el-form-item__content{
            margin-left: -25px;
          }
        }
        .expand .el-table__expand-column .cell {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Approve/AllApproveList.vue